import React, { Component } from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { ApplicationState } from "src/store/index";
import { FormComponentProps } from "antd/lib/form";
import { Form, Input, Spin, Upload, Button, Icon, Modal, Progress } from "antd";
import { LoadingType, PayType } from "src/store/pay/types";
import { fetchLoading, fetchOnePayFinish, fetchShowPic } from "src/store/pay/actions";
import { TOKEN, CID, LOCALHOST, ONE_M, LOGIN_URL } from "src/common/constants";
import MsModal from "src/components/ms-common/ms-modal/MsModal";
import Tools from "src/utils/tools";
import "./MsModalPay.scss";

interface PropsFromState {
  loading: LoadingType;
  onePay: PayType;
  userName: string;
  isShowPic: boolean;
}

interface PropsFromDispatch {
  loadingDisp: typeof fetchLoading;
  setOnePayDisp: typeof fetchOnePayFinish;
  showPicDisp: typeof fetchShowPic;
}

interface PropsOwn extends FormComponentProps{
  type: string;                                // 弹窗类型(cancel, upload, adjust, confirm, query, apply)
  record: any;                                 // 单条发放数据对象
  closeModal: () => void;                      // 关闭弹窗
  savePay: (data: any, type: string) => void;  // 点确定时把参数传给上层组件
}

type AllProps = PropsFromState & PropsFromDispatch & PropsOwn;

const FormItem = Form.Item;

const mapStateToProps = ({ payState, authorizationState }: ApplicationState) => ({
  loading: payState.loading,
  onePay: payState.onePay,
  userName: authorizationState.userInfo.uidName,
  isShowPic: payState.isShowPic
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loadingDisp: (data: any) => dispatch(fetchLoading(data)),
  setOnePayDisp: (data: any) => dispatch(fetchOnePayFinish(data)),
  showPicDisp: (data: any) => dispatch(fetchShowPic(data))
});

class MsModalPay extends Component<AllProps> {
  public hasFormData: any;         // 判断是否有formData
  public imagePath: string = "";   // 点击图片是存放图片路径

  constructor(props: any) {
    super(props);
    try {
      this.hasFormData = new FormData();
      this.hasFormData = true;
    } catch (err) {
      this.hasFormData = false;
    }
  }

  /**
   * 点击查看图片
   * @param   url   图片路径
   */
  public onClickPic = (url: string) => {
    return () => {
      this.imagePath = url;
      this.props.showPicDisp(true);
    }
  }
  /**
   * 关闭图片
   */
  public onClosePic = () => {
    this.props.showPicDisp(false);
  }
  
  /**
   * 上传文件组件的onChange方法
   * @param   acceptFiles   允许上传的类型
   * @param   limitSize     最大多少M
   */
  public uploadFile = (acceptFiles: string, limitSize: number) => {
    return (info: any) => {
      const status = info.file.status;
      if (status === "uploading") {
        this.props.loadingDisp({showB: true, text: "正在上传，请稍后..."})
      }
      if (status === 'done') {
        this.props.loadingDisp({showB: false, text: ""});
        const res = info.file.response;
        if (res) {
          if (this.props.type === "upload") {
            const index = info.file.name.lastIndexOf(".");
            if (acceptFiles && (index < 0 || acceptFiles.indexOf(info.file.name.substring(index).toLowerCase()) < 0)) {
              MsModal.error({content: `图片格式错误，请选择 ${acceptFiles} 格式的文件`});
              return;
            }
          }
          if (info.file.size > limitSize * ONE_M) {
            MsModal.error({content: `最大上传${limitSize}M的文件`});
            return;
          }
          if (res.result !== 0) {
            res.result === 401
            ? MsModal.error({
                content: "登陆已过期，请重新登陆！", onOk: () => {
                Tools.delCookie("ms_member_token");
                Tools.delCookie("ms_cid");
                location.href = LOGIN_URL;
              }
            })
            : MsModal.error({ content: res.detail });
          } else {
            this.onGetUploadResult({ ...res, name: info.file.name });
          }
        } else {
          MsModal.error({content: "上传文件失败"});
        }
      } else if (status === 'error') {
        this.props.loadingDisp({showB: false, text: ""})
        MsModal.error({content: "上传文件错误"});
      }
    }
  }
  /**
   * 删除图片
   * @param   index   索引
   */
  public delPic = (index: number) => {
    return (e: any) => {
      e.stopPropagation();
      const arr: any = this.props.onePay.imageList.filter((ele: any, i: number) => index !== i);
      this.props.setOnePayDisp({imageList: arr});
    }
  }
  /**
   * 检查长度，写在render中太长，所以抽出来写个函数
   */
  public onCheckLength = () => {
    const length = this.props.form.getFieldValue("rejectRemark").length;
    return length > 0 && length <= 200;
  }
  /**
   * 点确定时的操作（撤销弹窗）
   */
  public onSubmitCancel = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.props.savePay(
          {
            batchNo: this.props.record.batchNo,
            operater: this.props.userName,
            remark: values.rejectRemark.trim()
          },
          this.props.type
        );
      }
    })
  }
  /**
   * 点确定时的操作（名单调整弹窗）
   */
  public onSubmitAdjust = (e: any) => {
    e.preventDefault();
    const { record, type, onePay } = this.props;
    const { batchNo, specifyPayDate, remark, dataSource } = record;
    const param = {
      batchNo,
      specifyPayDate,
      remark,
      dataSource,
      bizLine: onePay.bizLine
    }
    this.props.savePay(param, type);
  }
  /**
   * 点确定时的操作（确认发放、上传凭证两个弹窗）
   * @param   data   对象
   */
  public onSubmitData = (data: any) => {
    return () => {
      this.props.savePay(data, this.props.type);
    }
  }
  /**
   * 上传凭证、名单调整两个弹窗的上传文件正确后的返回值
   * @param   res    上传文件正确后的返回值
   */
  public onGetUploadResult = (res: any) => {
    const p = res.data;
    const { type } = this.props;
    if (type === "upload") {
      const arr = [ ...this.props.onePay.imageList, {imageName: p.fileName, imageSize: p.size, imageUrl: p.filePath}];
      arr.length > 6
      ? MsModal.error({content: "上传图片最多6张"})
      : this.props.setOnePayDisp({imageList: arr});
    } else if (type === "adjust") {
      this.props.setOnePayDisp({fileName: res.name});
    }
  }
  /**
   * 当浏览器有formData时使用的上传方式
   * @param   file    文件
   */
  public onUploadFileWithXHR = (file: any) => {
    const url = `${ LOCALHOST }/salaryCpayCp/upload/uploadFile`;
    const fd = new FormData(); 
    fd.append("file", file); 
    fd.append("cid", CID);
    const xhr = new XMLHttpRequest();
    xhr.open("post", url, true);
    xhr.onload = (e: any) => {
      const res = JSON.parse(e.target.responseText);
      if (res.result === 0) {
        this.props.loadingDisp({showB: false, text: ""});
        this.onGetUploadResult(res);
      } else {
        let content: any = {
          content: res.detail
        }
        if (res.result === 401) {
          content =  {
            ...content,
            onOk: () => {
              Tools.delCookie("ms_member_token");
              Tools.delCookie("ms_cid");
              location.href = LOGIN_URL;
            }
          }
        }
        this.props.loadingDisp({showB: false, text: ""});
        MsModal.error(content);
      }
    };
    xhr.upload.onprogress = (e: any) => {
      const rate = ((e.loaded / e.total) * 100).toFixed(1);
      this.props.loadingDisp({showB: true, text: this.showProgress(rate)});
    }
    xhr.onerror = () => {
      this.props.loadingDisp({showB: false, text: ""});
      MsModal.error({content: "上传失败！"});
    };
    this.props.loadingDisp({showB: true, text: this.showProgress(0)});
    xhr.send(fd); // 提交
  }
  /**
   * 显示进度条
   * @param   rate    进度
   */
  public showProgress = (rate: string | number) => 
    <div className="upload-progress">
      正在上传，请稍后...
      <Progress percent={+rate} size="small" />
    </div>
  /**
   * 删除文件
   */
  public cleanFile = () => {
    this.props.setOnePayDisp({fileName: ""});
  }

  public render() {
    const { type, record, onePay, userName, isShowPic } = this.props;
    const { getFieldDecorator } = this.props.form;
    let title: object | string = "";
    let content: object | string = "";
    let btnDisabled: boolean = false;
    let onOk: any = null;
    let okText: string = "确定";
    switch (type) {
      case "cancel": {
        title = "确认撤销";
        content = 
          <div className="cancel-body-div">
            <Form>
              <FormItem label="撤销原因">
                {getFieldDecorator("rejectRemark", {
                  initialValue: "",
                  rules: [
                    { required: true, whitespace: true }
                  ]
                })(
                  <Input.TextArea placeholder="请输入撤销原因" maxLength={200} />
                )}
                <div className="show-length">
                  <span className={`${!this.onCheckLength() ? "error-color" : ""}`}>
                    {this.props.form.getFieldValue("rejectRemark").length}
                  </span>
                  /最多200字符
                </div>
              </FormItem>
            </Form>
          </div>;
        onOk = this.onSubmitCancel;
        break;
      }
      case "confirm":
      case "apply": {
        title = 
          <div className="confirm-title-div">
            <Icon type="question-circle" theme="filled" />
            是否确认发放
          </div>;
        content = 
          <div className="confirm-body-div">
            {type === "confirm"
              ? <div>认证结果：总{record.checkTotalNum}，成功{record.succCheckNum}，失败{record.failCheckNum}。只按认证成功进行发放。</div>
              : null
            }
            <div>发放时间：{record.specifyPayDate.substr(0, 10)}</div>
            <div>本次发放总额：{type === "confirm" ?  Tools.thousandSeparator((+record.checkSalaryAmount).toFixed(2)) : Tools.thousandSeparator((+record.totalAmount).toFixed(2))}</div>
            <div>发放笔数：{type === "confirm" ? record.checkSNum : record.totalNum}笔</div>
            <div>确认则进行发放任务发布，如有问题请调整发放名单后再确认。</div>
          </div>
        onOk = this.onSubmitData(
          type === "confirm"
            ? {
                batchNo: record.batchNo,
                operater: userName
              }
            : record
        );
        break;
      }
      case "query": {
        title = "查看凭证";
        content = onePay.imageList.map((ele: any, i: number) => {
          const imageName = ele.imageName || "";
          const index = imageName.lastIndexOf(".");
          const leftName = imageName.substring(0, index);
          const ext = imageName.substring(index);
          let size = ele.imageSize || 0;
          size = `${size > ONE_M ? `${(size / ONE_M).toFixed(1)}M` : (size > 1024 ? `${(size / 1024).toFixed(1)}KB` : `${size}B`)}`;
          return (
            <span className="pic-div" key={i}>
              <div className="pic-index">附件{i + 1}</div>
              <div className="pic-intro">
                <img src={ele.imageUrl} onClick={this.onClickPic(ele.imageUrl)} />
                <span className="pic-intro-right">
                  <div className="pic-word">
                    <span>{leftName}</span>
                    <span>{ext}</span>
                  </div>
                  <div className="pic-size">{size}</div>
                </span>
              </div>
            </span>
          )
        });
        onOk = null;
        break;
      }
      case "adjust": {
        const url = "salaryCpayCp/income/uploadIncomeFile";
        const acceptFiles = ".csv";
        const uploadParam = {
          batchNo: record.batchNo,
          bizLine: onePay.bizLine,
          cid: CID,
          token: TOKEN,
          totalAmount: "",
          totalNum: ""
        }
        const action = `${ LOCALHOST }/${ url }`;
        const uploadProps = {
          name: "file",
          action,
          data: uploadParam,
          onChange: this.uploadFile(acceptFiles, 100),
          showUploadList: false
        };
        title = "名单调整";
        okText = "确定上传";
        content = 
          <div className="adjust-body-div">
            <div className="tip-b">
              <Icon type="info-circle" theme="filled" />
              本次操作将覆盖原有数据
            </div>
            <Upload {...uploadProps} className="upload-btn">
              <Button>
                <Icon type="upload" />上传文件
              </Button>
            </Upload>
            <div className="file-name">
              {onePay.fileName
                ? <span>
                    <Icon type="paper-clip" />
                    <span className="f-name">{onePay.fileName}</span>
                    <Icon type="close" onClick={this.cleanFile} />
                  </span>
                : <span>支持扩展名：.CSV</span>
              }
            </div>
          </div>
        onOk = this.onSubmitAdjust;
        btnDisabled = onePay.fileName === "";
        break;
      }
      case "upload": {
        const currentDate = new Date().getTime();
        const payDate = new Date(`${this.props.record.specifyPayDate} 12:00:00`).getTime();
        const bool = currentDate > payDate;
        const picDiv = onePay.imageList.map((ele: any, i: number) => (
          <span key={ele.imageUrl} className="upload-pic-div">
            <img src={ele.imageUrl} className="pic" onClick={this.onClickPic(ele.imageUrl)} />
            <div className="del-pic" onClick={this.delPic(i)}>
              <Icon type="close" />
            </div>
          </span>
        ));
        const url = "salaryCpayCp/upload/uploadFile";
        const acceptFiles = ".jpg, .jpeg, .png, .bmp";
        const limitSize = 4;
        const uploadParam = { cid: CID }
        const uploadProps = this.hasFormData
        ? {
            name: "file",
            customRequest: (obj: any) => {
              const index = obj.file.name.lastIndexOf(".");
              if (index < 0 || acceptFiles.indexOf(obj.file.name.substring(index).toLowerCase()) < 0) {
                MsModal.error({content: `请选择${acceptFiles}格式的文件`});
                return;
              }
              if (obj.file.size > limitSize * ONE_M) {
                MsModal.error({content: `最大上传${limitSize}M的文件`});
                return;
              }
              this.onUploadFileWithXHR(obj.file);
            },
            showUploadList: false
          }
        : {
            name: "file",
            action: `${ LOCALHOST }/${ url }`,
            data: uploadParam,
            onChange: this.uploadFile(acceptFiles, limitSize),
            showUploadList: false,
          }
        title = "上传凭证";
        content = 
          <div className="upload-body-div">
            {bool
              ? <div className="tip-b">
                  <Icon type="info-circle" theme="filled" />
                  当前时间超过需发放日期的最晚提交时间，发薪时间将延后
                </div>
              : null
            }
            <div className="upload-area">
              <label>上传银行凭证：</label>
              <div className="upload-div">
                {onePay.imageList.length ? picDiv : null}
                {onePay.imageList.length < 6
                  ? <Upload.Dragger {...uploadProps} className="upload-btn">
                      <Icon type="plus" />
                      <div>上传图片</div>
                    </Upload.Dragger>
                  : null
                }
              </div>
            </div>
            <div className="tip-pic">
              仅支持图片格式：jpg、jpeg、png、bmp 最多6张，每张图片最大4M。
            </div>
          </div>;
        onOk = this.onSubmitData(
          {
            batchNo: record.batchNo,
            operater: this.props.userName,
            imgData: JSON.stringify(this.props.onePay.imageList)
          }
        );
        btnDisabled = onePay.imageList.length === 0;
      }
    }

    return(
      <MsModal
        className={`modal-pay-div ${type}`}
        visible={true}
        width={600}
        title={title}
        destroyOnClose={true}
        okText={okText}
        onCancel={this.props.closeModal}
        onOk={onOk}
        okButtonProps={{disabled: btnDisabled}}
        centered={true}
      >
        <div>
          {content}
        </div>
        <Spin tip={this.props.loading.text} className="spin-modal" spinning={this.props.loading.showB} size="large" />
        <Modal
          className="open-pic"
          visible={isShowPic}
          title={null}
          footer={null}
          destroyOnClose={true}
          maskClosable={true}
          onCancel={this.onClosePic}
        >
          <img src={this.imagePath} onClick={this.onClosePic} />
        </Modal>
      </MsModal>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(MsModalPay));





// WEBPACK FOOTER //
// ./src/components/ms-pay/ms-modal-pay/MsModalPay.tsx